import { bookingInquiryLogsApis } from '@apis/bookingInquiryLogsApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const usePatchBookingInquiryLog = (
  bookingInquiryD2dNo: string,
  bookingInquiryChangeLogGroupId: string,
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await bookingInquiryLogsApis.patch('/booking-inquiry-log/{group_id}/', {
        path: { group_id: bookingInquiryChangeLogGroupId },
        body: { has_read: true },
      });

      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/booking-inquiry/{id}/logs/', bookingInquiryD2dNo]);
      },
    },
  );
};
